import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import InfoItem from "./InfoItem";
import girlAvatar from "../assets/images/girlAvatar.png";

import { BusAttendanceChildStatus, ChildData } from "../types";

type ChildCardProps = {
  child: ChildData;
};

const attendanceTextByStatus = {
  [BusAttendanceChildStatus.PickedUp]: "Picked up",
};

const ChildCard = (props: ChildCardProps) => {
  return (
    <Row className="my-2">
      <Col xxl="auto" xs="auto">
        <img
          width={41}
          height={51}
          alt="child-profile-picture"
          src={props.child.profilePicture || girlAvatar}
          style={{ borderRadius: 6 }}
        />
      </Col>
      <Col>
        <Row>
          <span>
            {props.child.fname} {props.child.lname}
          </span>
        </Row>
        {props.child.status && (
          <Row>
            <InfoItem
              title={attendanceTextByStatus[props.child.status]}
              info={new Date(props.child.time).toLocaleTimeString()}
            />
          </Row>
        )}
      </Col>
      <Col xxl="auto" xs="auto">
        <div className="d-flex align-items-center h-100">
          <div
            style={{
              backgroundColor: props.child.branch.color,
              width: 18,
              height: 18,
              borderRadius: 9,
            }}
          />
        </div>
      </Col>
    </Row>
  );
};

export default ChildCard;
